import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { i18n as II18n } from 'i18next';

interface I18nProviderProps {
  value: II18n;
  children?: ReactNode;
}

export const I18nProvider = ({ value, ...props }: I18nProviderProps) => {
  return <I18nextProvider i18n={value} {...props} />;
};
